import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetValutrustMileStoneMessageStatus
} from '../state/actions/global-configuration.actions';

import { INTEGRATIONS } from '../model/global-configuration.constant';

@Injectable({
	providedIn: 'root'
})
export class ValutrustMessageLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetValutrustMileStoneMessageStatus(INTEGRATIONS.APPSCOPE)).toPromise();
			await this.store.dispatch(new SetValutrustMileStoneMessageStatus(INTEGRATIONS.ACUITY)).toPromise();
			await this.store.dispatch(new SetValutrustMileStoneMessageStatus(INTEGRATIONS.CMP_ACUTIY)).toPromise();
			return resolve(true);
		});
	}
}
